<template>
  <CautionArea cautionMessage="写真の不備による審査落ちが増えています">
    <p class="mb-2">写真アップロード時に、以下の点をご注意ください。</p>
    <div class="text-weight-500">
      <ol>
        <li v-for="caution in cautions" :key="caution">{{ caution }}</li>
      </ol>
      <slot />
    </div>
  </CautionArea>
</template>

<script lang="ts">
import { Vue, Prop, Component } from "vue-facing-decorator";

import CautionArea from "@/components/atoms/other/CautionArea.vue";
@Component({
  components: {
    CautionArea
  }
})
export default class UploadImageCautionArea extends Vue {
  @Prop({
    type: Array,
    required: true
  })
  cautions!: string[];
}
</script>

<style lang="scss" scoped>
ol {
  margin-left: 0.75rem;
  list-style: decimal;
}
</style>
